import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import omit from 'rc-util/lib/omit';
import RcSteps from 'rc-steps';
import CheckOutlined from '@ant-design/icons/CheckOutlined';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import classNames from 'classnames';
import { Progress } from '../Progress';
import useBreakpoint from '../Grid/hooks/useBreakpoint';
import { usePrefixCls } from '../../config/hooks/usePrefixCls';
var Steps = function Steps(props) {
  var percent = props.percent,
    size = props.size,
    className = props.className,
    direction = props.direction,
    responsive = props.responsive;
  var _useBreakpoint = useBreakpoint(),
    xs = _useBreakpoint.xs;
  var prefixCls = usePrefixCls('steps');
  var getDirection = React.useCallback(function () {
    return responsive && xs ? 'vertical' : direction;
  }, [xs, direction]);
  var stepsClassName = classNames(_defineProperty({}, "".concat(prefixCls, "-with-progress"), percent !== undefined), className);
  var icons = {
    finish: React.createElement(CheckOutlined, {
      className: "".concat(prefixCls, "-finish-icon")
    }),
    error: React.createElement(CloseOutlined, {
      className: "".concat(prefixCls, "-error-icon")
    })
  };
  var stepIconRender = function stepIconRender(_ref) {
    var node = _ref.node,
      status = _ref.status;
    if (status === 'process' && percent !== undefined) {
      var progressWidth = size === 'small' ? 32 : 40;
      var iconWithProgress = React.createElement("div", {
        className: "".concat(prefixCls, "-progress-icon")
      }, React.createElement(Progress, {
        type: "circle",
        percent: percent,
        width: progressWidth,
        strokeWidth: 4,
        format: function format() {
          return null;
        }
      }), node);
      return iconWithProgress;
    }
    return node;
  };
  return React.createElement(RcSteps, _objectSpread(_objectSpread({
    icons: icons
  }, omit(props, ['percent', 'responsive'])), {}, {
    direction: getDirection(),
    stepIcon: stepIconRender,
    prefixCls: prefixCls,
    className: stepsClassName
  }));
};
Steps.Step = RcSteps.Step;
Steps.defaultProps = {
  current: 0,
  responsive: true
};
export { Steps };